import classNames from 'classnames';
import { Icon } from 'framework/Icon';

import { useDropdownContext } from '../../dropdown/context/DropdownContext';
import { useOptionsTheme } from '../../Options/hooks/useOptionsTheme';
import { useOptionContext } from '../context/OptionContext';
import { OptionElement } from '../elements';

import { OptionProps } from './types';

import cn from '../Option.module.scss';

export const Option = ({ margin }: OptionProps) => {
  const { label, index, option } = useOptionContext();
  const { onSelect, onClose, keyboard_index, value, theme } = useDropdownContext();

  const options_theme = useOptionsTheme(theme?.options);
  const is_selected = option.value === value;
  const is_focused = index === keyboard_index;

  return (
    <OptionElement
      className={classNames('transparent', cn.option)}
      onMouseDown={() => {
        onClose();
        onSelect(option);
      }}
      is_focused={is_focused}
      is_selected={is_selected}
      style={{ height: options_theme.settings.option_height, margin }}
      theme={options_theme}
    >
      {option.icon && <Icon icon={option.icon} width="fit-content" />}
      <span>{label}</span>
    </OptionElement>
  );
};
